export default __webpack_public_path__ + "static/media/cs-a009-6.33b9b737.svg";